<template>
	<OrganismSlideshow v-bind="props">
		<div class="relative flex flex-col gap-8">
			<div>
				<AtomCardButton
					:variant="CardButtonVariant.LightBorder"
					label="Fysiotherapie"
					text="Plan je afspraak"
					icon="fa-arrow-right"
					@click="
						() => {
							trackButtonClick(
								'OrganismSlideshow_CTA_FysioAppointment',
							);
							emit('clickAppointmentButton');
						}
					"
				/>
			</div>
			<div class="min-h-[3.2rem]">
				<AtomRemainingSlotsButton
					@click="() => {
						trackButtonClick(
							'OrganismSlideshow_CTA_FysioAppointment_RemainingSlots',
						);
						emit('clickAppointmentButton');
					}"
				/>
			</div>
		</div>
	</OrganismSlideshow>
</template>

<script setup lang="ts">
import OrganismSlideshow from '#base/app/components/organism/Slideshow.vue';
import type { ImageType } from '#base/core/types/ImageType';
import type { SlideType } from '#base/core/types/SlideType';
import type { VideoType } from '#base/core/types/VideoType';
import { CardButtonVariant } from '#base/core/enums/CardButtonVariantEnum';

const props = defineProps<{
	slides: SlideType[];
	backgroundImage?: ImageType;
	backgroundVideo?: VideoType;
}>();

const {
	trackButtonClick,
} = useEventTracking();

const emit = defineEmits(['clickAppointmentButton']);
</script>
